import { c as _c } from "react/compiler-runtime";
import { ComponentType } from "react";
import { useFormContext } from "react-hook-form";
import { FormFieldLayout } from "../layouts/form-field-layout";
import { InputError } from "./input-error";
import { InputLabel } from "./input-label";
import { InputErrorStyleProps } from "./styles/input-error.styles";
import { InputLabelStyleProps } from "./styles/input-label.styles";
import { InputWrapperStyleProps } from "./styles/input-wrapper.styles";
import { TextAreaInputStyleProps } from "./styles/textarea-input.styles";
import { TextAreaInput } from "./textarea-input";
interface FormTextAreaProps {
  name: string;
  label: string;
  required?: boolean;
  error?: string;
  isValid?: boolean;
  placeholder?: string;
  dataCy?: string;
  disabled?: boolean;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  component?: ComponentType<any>;
  styles?: {
    wrapper?: InputWrapperStyleProps;
    error?: InputErrorStyleProps;
    label?: InputLabelStyleProps;
    textarea?: TextAreaInputStyleProps;
    layout?: {
      className?: string;
    };
  };
}
export const FormTextArea = t0 => {
  const $ = _c(29);
  const {
    name,
    label,
    required,
    error,
    isValid,
    value,
    placeholder,
    dataCy,
    disabled,
    styles,
    component: t1
  } = t0;
  const TextAreaComponent = t1 === undefined ? TextAreaInput : t1;
  const {
    register
  } = useFormContext();
  const t2 = styles?.layout?.className;
  const t3 = styles?.label;
  let t4;
  if ($[0] !== label || $[1] !== name || $[2] !== required || $[3] !== t3) {
    t4 = <InputLabel htmlFor={name} label={label} required={required} styles={t3} />;
    $[0] = label;
    $[1] = name;
    $[2] = required;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = styles?.wrapper;
  const t6 = styles?.textarea;
  let t7;
  if ($[5] !== name || $[6] !== register) {
    t7 = register(name);
    $[5] = name;
    $[6] = register;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== TextAreaComponent || $[9] !== dataCy || $[10] !== disabled || $[11] !== error || $[12] !== isValid || $[13] !== name || $[14] !== placeholder || $[15] !== required || $[16] !== t5 || $[17] !== t6 || $[18] !== t7 || $[19] !== value) {
    t8 = <TextAreaComponent id={name} error={error} isValid={isValid} placeholder={placeholder} required={required} dataCy={dataCy} disabled={disabled} wrapperStyles={t5} styles={t6} value={value} {...t7} />;
    $[8] = TextAreaComponent;
    $[9] = dataCy;
    $[10] = disabled;
    $[11] = error;
    $[12] = isValid;
    $[13] = name;
    $[14] = placeholder;
    $[15] = required;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
    $[19] = value;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== error || $[22] !== styles?.error) {
    t9 = error && <InputError error={error} styles={styles?.error} />;
    $[21] = error;
    $[22] = styles?.error;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t2 || $[25] !== t4 || $[26] !== t8 || $[27] !== t9) {
    t10 = <FormFieldLayout className={t2}>{t4}{t8}{t9}</FormFieldLayout>;
    $[24] = t2;
    $[25] = t4;
    $[26] = t8;
    $[27] = t9;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  return t10;
};